import * as firebase from 'firebase/app'
import * as React from 'react'
import { NavLink, Route, RouteComponentProps } from 'react-router-dom'

import Icon from 'components/Icon'
import InvoiceEditor from 'components/InvoiceEditor'

import AuthContext, { IAuthContext } from 'context/AuthContext'

import { IInvoice } from 'interfaces/IInvoice'
import { formatCurrency } from 'utils'

const assets = {
  awaiting: require('./awaiting.png'),
  paid: require('./paid.png'),
  unpaid: require('./unpaid.png'),
}

class Invoices extends React.Component<
  RouteComponentProps<{}> & {
    clients: IAuthContext['clients']
    company: IAuthContext['company']
    invoices: IAuthContext['invoices']
  }
> {
  public invoice = (id: string): IInvoice => {
    return this.props.invoices[id] || {}
  }

  get parseClientKey(): string {
    if (this.props.location.search.includes('?clientKey=')) {
      return this.props.location.search.replace('?clientKey=', '')
    }

    return ''
  }

  public setPaid(id: string) {
    const { currentUser } = firebase.auth()
    const { company } = this.props

    if (currentUser) {
      firebase
        .database()
        .ref(`invoices/${currentUser.uid}/${company}/${id}/unpaid`)
        .set(this.invoice(id).unpaid ? null : true)
    }
  }

  public status = (id: string) => {
    if (this.invoice(id).unpaid) {
      const expire = new Date(this.invoice(id).expire)
      if (expire.getTime() > Date.now()) {
        return <img src={assets.awaiting} />
      } else {
        return <img src={assets.unpaid} />
      }
    }

    return <img src={assets.paid} />
  }

  public sum = (id: string): string => {
    let sum = 0

    const { items, currency } = this.invoice(id)

    if (items) {
      items.forEach(item => (sum += item.sum))
    }

    return formatCurrency(sum, currency)
  }

  public delete(id: string) {
    const { currentUser } = firebase.auth()

    if (!currentUser) {
      throw new Error()
    }

    if (confirm('Are you sure?')) {
      firebase
        .database()
        .ref(`/invoices/${currentUser.uid}/${this.props.company}/${id}`)
        .set(null)
    }
  }

  public filterInvoices = (id: string) => {
    return this.parseClientKey
      ? this.props.invoices[id].clientKey === this.parseClientKey
      : true
  }

  public sortClients = (a: string, b: string) =>
    this.props.clients[a].name > this.props.clients[b].name ? 1 : -1

  public render() {
    const { props, invoice, status, sum } = this

    return (
      <div>
        <ul id="nav">
          <li>
            <NavLink activeClassName="active" exact to="/invoices">
              <Icon icon="view" />
              Visa fakturor
            </NavLink>
          </li>
          <li>
            <NavLink activeClassName="active" to="/invoices/create">
              <Icon icon="add" />
              Ny faktura
            </NavLink>
          </li>
        </ul>
        <Route
          exact
          path="/invoices"
          render={() => (
            <div>
              <select
                name="client"
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  this.props.history.push(
                    `/invoices${
                      e.currentTarget.value
                        ? '?clientKey=' + e.currentTarget.value
                        : ''
                    }`
                  )
                }
                value={this.parseClientKey}
              >
                <option value="">Visa alla fakturor</option>
                {Object.keys(props.clients)
                  .sort(this.sortClients)
                  .map(id => (
                    <option value={id} key={id}>
                      {props.clients[id] && props.clients[id].name}
                      {' - '}
                      {props.clients[id] && props.clients[id].reference}
                    </option>
                  ))}
              </select>
              <table>
                <thead>
                  <tr>
                    <th>Faktura</th>
                    <th>Företag/Namn</th>
                    <th>Belopp</th>
                    <th>Fakturadatum</th>
                    <th>Förfallodatum</th>
                    <th>Status</th>
                    <th colSpan={3} />
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(props.invoices)
                    .filter(this.filterInvoices)
                    .map(id => (
                      <tr key={id}>
                        <td className="id">{invoice(id).number}</td>
                        <td className="company">
                          <strong>{invoice(id).client.name}</strong>
                        </td>
                        <td style={{ textAlign: 'right' }}>{sum(id)}</td>
                        <td className="date">{invoice(id).date}</td>
                        <td className="date">{invoice(id).expire}</td>
                        <td className="delete">
                          <a onClick={() => this.setPaid(id)}>{status(id)}</a>
                        </td>
                        <td className="border">
                          <NavLink to={`/print/${this.props.company}/${id}`}>
                            <Icon icon="print" />
                          </NavLink>
                        </td>
                        <td className="border">
                          <NavLink to={`/invoices/edit/${id}`}>
                            <Icon icon="edit" />
                          </NavLink>
                        </td>
                        <td className="border">
                          <a onClick={() => this.delete(id)}>
                            <Icon icon="remove" />
                          </a>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        />
        <Route
          exact
          path="/invoices/create"
          render={p => props.company && <InvoiceEditor {...p} />}
        />
        <Route
          exact
          path="/invoices/edit/:id"
          render={p => props.company && <InvoiceEditor {...p} />}
        />
      </div>
    )
  }
}

export default (props: RouteComponentProps<{}>) => (
  <AuthContext.Consumer>
    {({ invoices, clients, company }) => (
      <Invoices
        {...props}
        company={company}
        clients={clients}
        invoices={invoices}
      />
    )}
  </AuthContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/containers/Invoices/Invoices.tsx